import { composeIO } from 'react-compose-io'
import { cabecalhoExportarRelatorioIO } from './CabecalhoExportarRelatorio.IO'
import { CabecalhoExportarRelatorioView } from './CabecalhoExportarRelatorio.View'

export const CabecalhoExportarRelatorio = composeIO(CabecalhoExportarRelatorioView, cabecalhoExportarRelatorioIO)
